import { BillFilters } from "@common/contracts/bill.contract";
import { omit } from "@common/helpers/objects";
import { BillStatusFilter } from "@common/schemas/domains/bills/bill-status-filter.schema";
import { BillStatus } from "@common/types/bill";
import { narrowStatusFilterToStatus, readStatusFilter } from "./statusFilter";

type BillStatusFilterFields = Pick<
    BillFilters,
    "billStatusFilter" | "billStatuses" | "externalBillStatuses"
>;

const LEGACY_STATUS_KEYS = [
    "billStatuses",
    "externalBillStatuses",
] as const satisfies ReadonlyArray<keyof BillStatusFilterFields>;

export const BILL_STATUS_VALUES = Object.values(BillStatus);

export function readBillStatusFilter(
    filters: BillStatusFilterFields,
): BillStatusFilter | undefined {
    return readStatusFilter({
        statusFilter: filters.billStatusFilter,
        kickStatuses: filters.billStatuses,
        externalStatuses: filters.externalBillStatuses,
    });
}

export function normalizeBillStatusFilters<T extends BillStatusFilterFields>(
    filters: T,
) {
    const billStatusFilter = readBillStatusFilter(filters);
    const rest = omit(filters, [...LEGACY_STATUS_KEYS]);
    return billStatusFilter ? { ...rest, billStatusFilter } : rest;
}

export function narrowBillStatusFilterToStatus({
    statusFilter,
    status,
}: {
    statusFilter: BillStatusFilter;
    status: BillStatus;
}): BillStatusFilter | null {
    return narrowStatusFilterToStatus({
        statusFilter,
        status,
        allStatuses: BILL_STATUS_VALUES,
    });
}
